// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper__3yRLr"};